import { ApplicationStatus } from '@/types/api.ts';

const applicationIsOfStatus = (status: ApplicationStatus) => {
  return (applicationStatus: ApplicationStatus) => {
    return applicationStatus === status;
  };
};

const applicationCompleted = applicationIsOfStatus('completed');

const applicationWorkedByApplicant = applicationIsOfStatus('worked_by_applicant');

export {
  applicationCompleted,
  applicationIsOfStatus,
  applicationWorkedByApplicant
};
